export class LaborByLevel {
  levelID: number = 0;
  levelDescription: string = '';
  laborType: string = '';
  servicingOffice: string = '';
  standardRate: number = 0;
  baseHours: number = 0;
  adjustmentHours: number = 0;
  hoursTotal: number = 0;
  otpwr: string = '';
  costTotal: number = 0;
  typicalOfCount: string = '';
  systemDifficultyLevel: string = '';
}
